import { ArrowUpRight, MapPin } from "lucide-react";
import { useLang } from "@/i18n";
import { IMG } from "@/data/media";
import { FadeUp } from "@/components/motion";
import { L } from "@/components/L";

const Card = ({ to, img, alt, place, name, text, corner, delay, testId }) => {
  const { t } = useLang();
  return (
    <FadeUp delay={delay}>
      <L to={to} className="group block" data-testid={testId}>
        <div className={`relative aspect-[4/3] overflow-hidden img-zoom ${corner} bg-[var(--green-pale)]`}>
          <img src={img} alt={alt} loading="lazy" className="photo absolute inset-0 w-full h-full object-cover" />
          <span className="absolute right-5 top-5 h-14 w-14 grid place-items-center rounded-full bg-[var(--yellow)] text-[var(--ink)] transition-transform duration-500 group-hover:rotate-45"><ArrowUpRight /></span>
        </div>
        <p className="mt-6 flex items-center gap-2 text-sm font-semibold text-[var(--green-deep)]"><MapPin size={15} /> {place}</p>
        <h3 className="mt-2 text-3xl sm:text-4xl leading-tight">{name}</h3>
        <p className="mt-3 text-[var(--ink-soft)] leading-relaxed max-w-xl">{text}</p>
        <span className="mt-5 inline-block font-semibold link-u">{t.common.discover}</span>
      </L>
    </FadeUp>
  );
};

export const ProjectCards = () => {
  const { t } = useLang();
  const p = t.projects;
  return (
    <div className="grid gap-12 md:grid-cols-2 md:gap-8">
      <Card to="laRomana" img={IMG.kidsBanner} alt={t.gallery.captions.kidsBanner} place={p.laRomana.place} name={p.laRomana.name} text={p.laRomana.short} corner="rounded-[2.5rem_2.5rem_2.5rem_0.5rem]" delay={0} testId="project-card-la-romana" />
      <div className="md:mt-24">
        <Card to="villa" img={IMG.render3d} alt={t.gallery.captions.render3d} place={p.villa.place} name={p.villa.name} text={p.villa.short} corner="rounded-[2.5rem_0.5rem_2.5rem_2.5rem]" delay={0.1} testId="project-card-villa" />
      </div>
    </div>
  );
};
